<template>
  <div class="width-100 min-height bg-image flex-column align-items-center justify-content-start position-relative" id="body-div">
    <div
      class="first-div textAlign-c white fm-sh-medium fs-sml"
      :style="{ height: bodyWidth * 0.66 * 0.12 + 'px', width: '66%', lineHeight: bodyWidth * 0.66 * 0.12 + 'px', marginTop: '10%' }"
    >
      参与签到获取抽奖次数
    </div>
    <van-image
      :src="require('../assets/image/sweepstakesPage/title.png')"
      width="80%"
      :height="bodyWidth * 0.9 * 0.15 + 'px'"
      fit="fill"
      style="margin-top: 5%; margin-bottom: 3%"
    />
    <div
      v-if="itemDetail.is_open_smoke == 2"
      class="second-div textAlign-c fs-mid-sml white fm-sh-regular"
      :style="{ width: '40%', height: bodyWidth * 0.4 * 0.25 + 'px', lineHeight: bodyWidth * 0.4 * 0.25 + 'px' }"
    >
      剩余抽奖次数：<span style="color: #fef037" class="fs-mid fm-sh-medium">{{ itemDetail.lottery_num }}</span>
    </div>
    <!-- 抽奖转盘 -->
    <div
      class="chou-jiang width-100 flex-row align-items-center justify-content-spaceBetween flex-wrap"
      :style="{ height: (bodyWidth * 641) / 736 + 'px', padding: '8%' }"
    >
      <div v-for="(item, key) in giftList" :key="key" class="width-32 br-reg" style="height: 32%">
        <div v-if="key != 4" :class="['width-100 bg-gift-image height-100 flex-column align-items-center justify-content-center position-relative']">
          <div
            v-if="activeItem === key"
            class="width-100 height-100 br-reg"
            style="position: absolute; background: #ffc72338; top: 0; left: 0; z-index: 10"
          ></div>
          <van-image :src="item.picture_url" width="60%" height="60%" fit="contain" />
          <div class="fs-sml textAlign-c black fm-sh-regular width-100 show-line-1 canNotWrap" style="padding: 0 5px">{{ item.name }}</div>
        </div>
        <van-image
          v-else-if="itemDetail.is_open_smoke == 2 && key == 4"
          :src="item.picture_url"
          width="100%"
          height="100%"
          @click="itemDetail.is_open_smoke == 1 ? '' : lottery()"
        />
        <div v-else-if="itemDetail.is_open_smoke == 1 && key == 4" class="width-100 height-100 br-reg overflow-h position-relative">
          <div class="width-100 height-100 position-absolute" style="top: 0; left: 0">
            <van-image :src="item.picture_url" width="100%" height="100%" />
          </div>
          <div class="width-100 height-100 flex-column align-items-center justify-content-center position-relative" style="z-index: 1">
            <div class="fs-super-big fw-bold" style="color: #c10102">
              {{ itemDetail.lottery_num }}
            </div>
            <div class="fs-sml fw-mid margin-ts" style="zoom: 0.83; color: #c10102">剩余抽奖次数：</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 抽奖10次或者1次 -->
    <div v-if="itemDetail.is_open_smoke == 1" class="width-100 margin-t15 flex-row align-items-center justify-content-around" style="padding: 0 3%">
      <van-image
        width="40%"
        :height="(bodyWidth * 0.94 * 0.4 * 364) / 1132 + 'px'"
        :src="require('../assets/image/sweepstakesPage/csc.png')"
        @click="lotteryTen()"
      />
      <van-image
        width="40%"
        :height="(bodyWidth * 0.94 * 0.4 * 364) / 1132 + 'px'"
        :src="require('../assets/image/sweepstakesPage/cyc.png')"
        @click="lottery()"
      />
    </div>
    <div class="width-100" style="padding: 0 3%; margin-top: 10%; margin-bottom: 10%">
      <div style="padding: 2% 2% 3%; background: #ff5555" class="width-100 br-mid">
        <div class="width-100 bg-white br-mid flex-column align-items-center justify-content-center" style="padding: 5% 3%">
          <div class="width-100 flex-row align-items-center justify-content-spaceBetween" style="background: #ffb380; height: 1.5rem">
            <div class="width-30 textAlign-c white fm-sh-regular fs-sml">中奖人</div>
            <div class="width-70 textAlign-c white fm-sh-regular fs-sml">奖品名称</div>
          </div>
          <div v-if="winningRecordList.length != 0" style="max-height: 200px; overflow-y: scroll" class="width-100 scroll-h" id="body-list">
            <div
              v-for="(item, key) in winningRecordList"
              :key="key"
              class="width-100 flex-row align-items-center justify-content-spaceBetween"
              style="height: 1.5rem"
            >
              <div class="width-30 textAlign-c darkgrey fm-sh-regular fs-sml canNotWrap show-line-1">{{ item.member_nickname }}</div>
              <div class="width-70 textAlign-c darkgrey fm-sh-regular fs-sml canNotWrap show-line-1">{{ item.name }}</div>
              <!-- <div class="width-35 textAlign-c darkgrey fm-sh-regular fs-sml canNotWrap show-line-1">{{ item.cre_time }}</div> -->
            </div>
          </div>
          <van-empty v-show="winningRecordList.length == 0" description="暂无中奖记录" />
        </div>
      </div>
    </div>
    <!-- <div
      class="flex-column align-items-center justify-content-center"
      style="
        position: fixed;
        right: 0;
        top: 15%;
        width: 1.35rem;
        background: rgba(193, 2, 2, 0.58);
        border-top-left-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
      "
      @click="show = true"
    >
      <div class="white fm-sh-light" style="font-size: 12px; transform: scale(0.8)">抽</div>
      <div class="white fm-sh-light" style="font-size: 12px; transform: scale(0.8)">奖</div>
      <div class="white fm-sh-light" style="font-size: 12px; transform: scale(0.8)">规</div>
      <div class="white fm-sh-light" style="font-size: 12px; transform: scale(0.8)">则</div>
    </div> -->
    <div style="width: 1.53rem; height: 4.68rem; position: fixed; right: 0; top: 15%" @click="show = true">
      <van-image :src="require('../assets/image/home/cjgz.png')" width="1.53rem" height="4.68rem" />
    </div>
    <div
      v-if="show"
      class="flex-column align-items-center justify-content-center width-100"
      style="position: fixed; top: 0; left: 0; height: 100vh; z-index: 50; background: rgba(0, 0, 0, 0.3)"
    >
      <div
        class="width-80 gui-ze flex-row align-items-center justify-content-center"
        :style="{ height: ((bodyWidth * 0.8) / 600) * 715 + 'px', padding: '15% 0' }"
      >
        <div class="width-80" style="height: 100%; overflow-y: scroll">
          <div v-html="itemDetail.rules" class="width-100" style="height: auto; overflow: scroll"></div>
        </div>
      </div>
      <div
        @click="show = false"
        style="background: rgba(51, 51, 51, 0.5); width: 28px; height: 28px"
        class="br-rol flex-row align-items-center justify-content-center"
      >
        <van-icon name="cross" size="20" color="#fff" />
      </div>
    </div>
    <van-overlay :show="show2" class="flex-column align-items-center justify-content-center">
      <div v-if="iszhongjiang" class="width-80 xxhg" :style="{ height: ((bodyWidth * 0.8) / 600) * 750 + 'px', zIndex: '200' }"></div>
      <div
        v-else
        class="width-80 gxzj position-relative flex-row align-items-center justify-content-center"
        :style="{ height: ((bodyWidth * 0.8) / 600) * 750 + 'px', zIndex: '200' }"
      >
        <div class="position-absolute flex-column align-items-center justify-content-center" style="bottom: 22%; margin: 0 auto">
          <van-image :src="zhongjiang" width="5rem" height="3.5rem" fit="contain" />
          <div style="width: 8rem" class="textAlign-c black canNotWrap">{{ jpmc }}</div>
        </div>
      </div>
      <div
        @click="show2 = false"
        style="background: rgba(51, 51, 51, 0.5); width: 28px; height: 28px"
        class="br-rol flex-row align-items-center justify-content-center margin-ts"
      >
        <van-icon name="cross" size="20" color="#fff" />
      </div>
    </van-overlay>
    <div
      v-if="showLotteryTen"
      class="flex-column align-items-center justify-content-center"
      :style="{
        zIndex: 9999,
        background: 'rgba(0, 0, 0, 0.5)',
        position: 'fixed',
        top: 0,
        left: 0,
        width: bodyWidth + 'px',
        height: bodyHeight + 'px'
      }"
    >
      <div class="width-100 bg-i flex-column align-items-center justify-content-center" :style="{ height: (bodyWidth * 3804) / 3000 + 'px' }">
        <div style="border: 10px solid #fcd598" class="width-90 bg-white br-reg flex-column align-items-center justify-content-start padding-lr-15">
          <div style="margin-top: -40px; width: 80px; height: 80px" class="br-rol overflow-h">
            <van-image width="100%" height="100%" :src="require('../assets/image/sweepstakesPage/truefinish.png')" />
          </div>
          <div class="width-100 textAlign-c fs-mid margin-ts fw-bold">恭喜您抽中以下奖品</div>
          <div
            class="width-100 scroll-h margin-ts flex-row align-items-center justify-content-start"
            style="height: 130px; z-index: 999; overflow-x: scroll"
          >
            <div class="flex-column margin-r align-items-center justify-content-around height-100" v-for="(item, key) in lotteryTenList" :key="key">
              <div
                style="width: 100px; height: 100px; background: linear-gradient(to bottom, #fce2b0, #fcd598)"
                class="br-reg flex-column align-items-center justify-content-center"
              >
                <van-image width="80px" height="80px" :src="item.picture_url" fit="contain" />
              </div>
              <div class="fs-mid textAlign-c grey-999 show-line-1 canNotWrap" style="width: 100px">
                {{ item.name }}<span v-if="item.num && item.type != 4"> * {{ item.num }}</span>
              </div>
            </div>
          </div>
          <div
            class="width-30 white fs-mid textAlign-c margin-ts margin-b15"
            style="background: linear-gradient(to bottom, #ffcd6a, #fe7602); border-radius: 2px; padding: 2px 0"
            @click="showLotteryTen = false"
          >
            开心收下
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let interval = null;
// eslint-disable-next-line no-unused-vars
import { getTurntableInfo, lottery, getActivityMemberTicketLists, ten_lottery } from '@/api/sweepstakesPage';
import { Toast } from 'vant';
export default {
  data() {
    return {
      jpmc: '',
      zhongjiang: '',
      iszhongjiang: false,
      show2: false,
      bodyHeight: '',
      show: false,
      itemDetail: {},
      bodyWidth: 0,
      winningRecordList: [],
      giftList: [],
      activeItem: 0,
      showLotteryTen: false,
      lotteryTenList: [],
      loading: false,
      top: 0
    };
  },
  beforeMount() {
    this.getTurntableInfo();
    this.$nextTick(() => {
      this.bodyWidth = document.getElementById('body-div').clientWidth;
      this.bodyHeight = document.getElementById('body-div').clientHeight;
    });
  },
  watch: {
    '$route.path': {
      deep: true,
      handler(val) {
        if (val != '/sweepstakesPage') {
          clearInterval(interval);
          this.$destroy();
        }
      }
    }
  },
  methods: {
    getActivityMemberTicketLists() {
      getActivityMemberTicketLists({ id: this.itemDetail.id, type: 3 })
        .then((res) => {
          if (res.code == 0) {
            this.winningRecordList = res.data;
            this.$nextTick(() => {
              console.log(document.getElementById('body-list').scrollHeight, document.getElementById('body-list').offsetHeight);
              clearInterval(interval);
              interval = setInterval(() => {
                console.log(this.top < document.getElementById('body-list').scrollHeight - document.getElementById('body-list').offsetHeight);
                if (this.top < document.getElementById('body-list').scrollHeight - document.getElementById('body-list').offsetHeight) {
                  document.getElementById('body-list').scrollTop = this.top + 1;
                  this.top += 1;
                } else {
                  this.top = 0;
                  document.getElementById('body-list').scrollTop = 0;
                }
              }, 50);
            });
          } else {
            Toast.fail(res.msg);
          }
        })
        .catch((err) => console.log(err));
    },
    getTurntableInfo() {
      let time = new Date();
      getTurntableInfo({ month: time.getMonth() + 1 }).then((res) => {
        if (res.code == 0) {
          this.itemDetail = res.data;
          let list = res.data.goods_lists.map((item) => {
            item.activeItem = false;
            return item;
          });
          list.splice(4, 0, {
            picture_url:
              res.data.is_open_smoke == 2
                ? require('../assets/image/sweepstakesPage/lijichou.png')
                : require('../assets/image/sweepstakesPage/lijichou2.png'),
            name: ''
          });
          this.giftList = list;
          this.getActivityMemberTicketLists();
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    async lottery() {
      let _this = this;
      if (this.itemDetail.lottery_num == 0) {
        Toast.fail('抱歉，您暂无抽奖机会！请完成任务获取抽奖机会！');
        return;
      }
      if (this.loading) {
        return;
      }
      this.loading = true;
      await lottery({ id: this.itemDetail.id }).then((res) => {
        if (res.code == 0) {
          this.itemDetail.lottery_num -= 1;
          let idex = 0;
          this.giftList.forEach((item, index) => {
            if (item.id == res.data.id) {
              idex = index;
            }
          });
          let lunshu = Math.floor(Math.random() * 2 + 1);
          let keylist = [0, 1, 2, 5, 8, 7, 6, 3];
          let key_num = keylist.findIndex((it) => it == idex);
          let listkey = [];
          for (let i = 0; i < (lunshu + 2) * 8; i++) {
            listkey = listkey.concat(keylist);
          }
          for (let i = 0; i < lunshu * 8 + key_num + 1; i++) {
            setTimeout(() => {
              _this.activeItem = listkey[i];
              if (i == lunshu * 8 + key_num) {
                setTimeout(() => {
                  if (res.data.type == 4) {
                    this.show2 = true;
                    this.iszhongjiang = true;
                  } else {
                    this.show2 = true;
                    this.iszhongjiang = false;
                    this.zhongjiang = res.data.picture_url;
                    this.jpmc = res.data.name + (res.data.num ? `×${res.data.num}` : '');
                  }
                  this.loading = false;
                }, 600);
              }
            }, 200 * i);
          }
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    async lotteryTen() {
      let _this = this;
      if (this.itemDetail.lottery_num == 0) {
        Toast.fail('抱歉，您暂无抽奖机会！请完成任务获取抽奖机会！');
        return;
      }
      if (this.itemDetail.lottery_num < 10) {
        Toast.fail('抱歉，您的抽奖机会低于10次，请完成任务获取抽奖机会！');
        return;
      }
      if (this.loading) {
        return;
      }
      this.loading = true;
      let num = this.itemDetail.lottery_num < 10 ? this.itemDetail.lottery_num : 10;
      this.itemDetail.lottery_num -= num;
      await ten_lottery({ id: this.itemDetail.id }).then((res) => {
        if (res.code == 0) {
          let list = res.data;
          let idex = 0;
          this.giftList.forEach((item, index) => {
            if (item.id == list[list.length - 1].id) {
              idex = index;
            }
          });
          let lunshu = Math.floor(Math.random() * 2 + 1);
          let keylist = [0, 1, 2, 5, 8, 7, 6, 3];
          let key_num = keylist.findIndex((it) => it == idex);
          let listkey = [];
          for (let i = 0; i < (lunshu + 2) * 8; i++) {
            listkey = listkey.concat(keylist);
          }
          for (let i = 0; i < lunshu * 8 + key_num + 1; i++) {
            setTimeout(() => {
              _this.activeItem = listkey[i];
              if (i == lunshu * 8 + key_num) {
                setTimeout(() => {
                  this.lotteryTenList = list;
                  this.showLotteryTen = true;
                  this.loading = false;
                }, 600);
              }
            }, 200 * i);
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.first-div {
  background-image: url('../assets/image/sweepstakesPage/first.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.bg-image {
  background-image: url('../assets/image/sweepstakesPage/bg-image.png');
  background-size: 100% 100%;
}
.second-div {
  background-image: url('../assets/image/sweepstakesPage/second.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.chou-jiang {
  background-image: url('../assets/image/sweepstakesPage/choujiang.png');
  background-size: 100%;
  background-repeat: no-repeat;
}
.gui-ze {
  background-image: url('../assets/image/sweepstakesPage/gui-ze.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.bg-gift-image {
  background-image: url('../assets/image/sweepstakesPage/bg-gift-image.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.xxhg {
  background-image: url('../assets/image/sweepstakesPage/xxhg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.gxzj {
  background-image: url('../assets/image/sweepstakesPage/gxzj.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
::v-deep .van-overlay {
  z-index: 200 !important;
}
.bg-i {
  background-image: url('../assets/image/sweepstakesPage/bg-gift.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
